// "New version · Update" toast (docs/project.md §8, State-Update board). registerType 'prompt':
// the new service worker waits until the user confirms.
import { useTranslations } from 'use-intl';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { track } from '@/lib/analytics';

export function UpdatePrompt() {
  const t = useTranslations('update');
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Re-check for a new build whenever the app returns to the foreground
      if (!registration) return;
      document.addEventListener('visibilitychange', () => {
        // A failed fetch of sw.js (a flaky network on wake-up) is retried on the next return
        if (document.visibilityState === 'visible') registration.update().catch(() => undefined);
      });
    },
  });
  if (!needRefresh) return null;
  return (
    <div
      role="status"
      className="fade-in fixed left-4 right-4 bottom-[106px] z-50 mx-auto flex h-[52px] max-w-[520px] items-center gap-3 rounded-[14px] bg-ink pl-4 pr-2 text-ink-inverse shadow-[0_8px_24px_rgba(28,28,30,0.28)] desktop:bottom-6"
    >
      <span className="flex-grow text-[15px] font-medium">{t('newVersion')}</span>
      <button
        type="button"
        className="h-9 rounded-[9px] bg-white/15 px-3 text-[15px] font-semibold"
        onClick={() => {
          setNeedRefresh(false);
          track('app_updated');
          void updateServiceWorker(true);
        }}
      >
        {t('update')}
      </button>
    </div>
  );
}
